var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rendered)?_c('runtime-template-compiler',{staticStyle:{"height":"100%"},attrs:{"template":_vm.html}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }